<p-panel>
  <ng-template #header>
    <div class="flex items-center w-full">
      <div class="flex items-center">
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-search"></i>
          </p-inputgroup-addon>
          <input
            pInputText
            type="text"
            [(ngModel)]="searchTerm"
            (input)="onSearchInput()"
            placeholder="Suche"
            spellcheck="false"
            autocomplete="off"
          />
          <p-inputgroup-addon class="ml-[-40px] z-20">
            <i class="pi pi-times" (click)="clearSearch()" style="cursor: pointer;" *ngIf="searchTerm.length > 0"></i>
          </p-inputgroup-addon>
        </p-inputgroup>
      </div>
      <div class="grow"></div>
      <div class="flex items-center">
        <p-button
          label="{{ 'animalOverview.newAnimal' | transloco }}"
          icon="pi pi-plus"
          iconPos="left"
          (click)="toggleAddDialog()"
          data-cy="open-animal-dialog-btn"
        ></p-button>
      </div>
    </div>
  </ng-template>

  <p-dataview
      #dv
      [value]="filteredAnimals"
      [layout]="layout"
      [paginator]="layout === 'grid' ? true : false"
      [rows]="rowCount"
      [first]="first"
      (onPage)="onPageChange($event)"
  >
    <ng-template #header>
      <div class="flex flex-wrap items-center justify-between w-full">
        <app-animal-filters (searchEvent)="handleSearch($event)"></app-animal-filters>

        <p-selectbutton [(ngModel)]="layout" [options]="['list','grid']" [allowEmpty]="false" (ngModelChange)="onLayoutChange($event)">
          <ng-template #item let-opt>
            <i class="pi" [ngClass]="{ 'pi-bars': opt === 'list', 'pi-table': opt === 'grid' }"></i>
          </ng-template>
        </p-selectbutton>
      </div>
    </ng-template>
    <ng-template #grid let-items>
      <div class="grid grid-cols-12 gap-2 pt-3 pb-3">
        @for (animal of items; track animal.id) {
          <div class="col-span-12 lg:col-span-4 xl:col-span-4 cursor-pointer" [routerLink]="['/tiere', animal.id]">
            <div class="p-0 rounded-md shadow-sm hover:shadow-lg bg-white border-1 border-(--p-primary-200)">
              <div class="grid grid-cols-12">
                <div class="col-span-12 flex justify-center pb-0">
                  <div class="flex flex-col w-full h-[22rem] relative">
                    <app-animal-image-container
                      [preview]="true"
                      [animal]="animal"
                    />
                  </div>
                </div>
                <div class="col-span-12 flex items-center py-0">
                  <div class="flex justify-start w-1/4">
                    <app-animal-current-category [type]="'small'" [animal]="animal"></app-animal-current-category>
                  </div>
                  <div class="flex justify-center w-2/4">
                    <div class="flex flex-col items-center">
                      <p class="text-center font-semibold m-0" style="font-size: 20px">
                        {{ animal?.displayName }}
                      </p>
                      <p>
                        {{ animal.bookNumber }}
                        @if (animal.oldBookNumber) {
                          <span>({{ animal.oldBookNumber }})</span>
                        }
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-col justify-center items-center w-1/4">
                    <app-animal-sex-icon [animal]="animal"></app-animal-sex-icon>
                    @if (animal.birthYear) {
                      <p>{{ animal.birthYear | date: 'yyyy' }}</p>
                    }
                    @if (animal.birthday) {
                      <p>{{ animal.birthday | date: 'dd.MM.yyyy' }}</p>
                    }
                  </div>
                </div>
                <div class="col-span-12">
                  <app-animal-labels [animal]="animal"/>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </ng-template>
  </p-dataview>
  @if (layout === 'list') {
    <app-animal-list-item
      [animals]="filteredAnimals"
      [pageable]="true"
      [pageSize]="rowCount"
      [first]="first"
      (pageChange)="onListPageChange($event)"
    ></app-animal-list-item>
  }
</p-panel>
@if (addDialogVisible) {
  <app-animal-add-dialog></app-animal-add-dialog>
}
